import script from "./GetStartedQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStartedQuiz.vue?vue&type=script&setup=true&lang=js"

import "./GetStartedQuiz.vue?vue&type=style&index=0&id=afa68218&lang=scss&scoped=true"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa68218"]])

export default __exports__